import { storageFactory } from 'storage-factory';

export const storage = {
  local: storageFactory(() => localStorage),
  session: storageFactory(() => sessionStorage),
};
